module.exports = __webpack_public_path__ + "static/img/Jizhi_Chair.585b636e.png";